/// <reference path="../app.ts" />
namespace Cfnc {
    "use strict";

    interface IuncSchoolsScope extends ng.IScope {
        vm: uncSchoolsCtrl
    }
    interface IuncSchoolsCtrl {
        uncSchools: Array<any>;
        show: string;
        activate: () => void;
    }

    class uncSchoolsCtrl implements IuncSchoolsCtrl {
        static controllerId: string = "uncSchoolsCtrl";

        static $inject: string[] = ["$location", "common", "$sce", "$sanitize", "Restangular"];

        uncSchools: Array<any>;
        show: string;
        errorReason: string;
        log: (msg, data?, showToast?) => void;
        logError: (msg, data?, showToast?) => void;
        logSuccess: (msg, data?, showToast?) => void;

        constructor(private $location: ng.ILocationService, private common: ICommonFactory, private $sce: ng.ISCEService, private $sanitize: ng.sanitize.ISanitizeService, private Restangular: Restangular.IService) {
            this.log = common.logger.getLogFn(uncSchoolsCtrl.controllerId);
            this.logError = common.logger.getLogFn(uncSchoolsCtrl.controllerId, "error");
            this.logSuccess = common.logger.getLogFn(uncSchoolsCtrl.controllerId, "success");
            this.activate();
        }

        activate() {
            var promises = [];
            this.common.activateController(promises, uncSchoolsCtrl.controllerId).then(() => {
                this.show = "appStatePage";
                this.getUncSchools();
            });
        }

        getUncSchools(): ng.IPromise<any> {
            return this.Restangular.all("institutions/getUncSchools").getList().then((result) => {
                this.uncSchools = result;

            }, (reason) => {
                this.errorReason = reason;
                this.show = "Error";
                this.logError(reason, reason);
            });
        }

        validateHtml(html: any) {
            return this.$sce.trustAsHtml(html);
            //return html;
        }

        formatDate(origDate: Date) {
            var test = new Date(origDate.toString()).toLocaleDateString();
            return test;
        }
    }

    angular.module("app").controller("uncSchoolsCtrl", uncSchoolsCtrl);
}